import { isEmpty } from "lodash";
import axiosInstance from "./base";
import { AxiosResponse } from "axios";

export type Count = {
    count: number,
    '@id': string
}

export class Stats {

    static getDistanceCount(options: string[] = []): Promise<AxiosResponse<Count>> {
        return axiosInstance.get('count/cumulated_training_distance'
            .concat(!isEmpty(options) ? `?${options.join('&')}` : '')
        )
    }

    static geteTimeCount(options: string[] = []): Promise<AxiosResponse<Count>> {
        return axiosInstance.get('count/cumulated_training_time'
            .concat(!isEmpty(options) ? `?${options.join('&')}` : '')
        )
    }

    static getHorsesCount(options: string[] = []): Promise<AxiosResponse<Count>> {
        return axiosInstance.get('count/monitored_horses'
            .concat(!isEmpty(options) ? `?${options.join('&')}` : '')
        )
    }

    static getTrainingsCount(options: string[] = []): Promise<AxiosResponse<Count>> {
        return axiosInstance.get('count/trainings'
            .concat(!isEmpty(options) ? `?${options.join('&')}` : '')
        )
    }

}